"use client";

import { usePathname } from "next/navigation";
import { NavBar } from "./nav-bar";
import { Footer } from "./footer";

/**
 * Routes that bring their own navigation, footer and scrolling model. Matched
 * exactly: /v2 has no sub-routes, so /v2/anything is a 404 that should keep the
 * site chrome like any other.
 */
const isStandaloneRoute = (pathname: string) => pathname.replace(/\/+$/, "") === "/v2";

/**
 * The site navigation, footer and the ScrollSmoother wrapper.
 *
 * The design v2 preview is rendered outside all three: the wrapper's
 * `overflow: hidden` defeats `position: sticky`, and its `will-change:
 * transform` turns every fixed element inside it into one that scrolls away,
 * so the preview's pinned scenes and instrument rail could not work inside it.
 */
export const SiteChrome = ({ children }: { children: React.ReactNode }) => {
  const pathname = usePathname();

  if (isStandaloneRoute(pathname)) return <>{children}</>;

  return (
    <>
      <NavBar />
      <div id="smooth-wrapper">
        <div id="smooth-content">
          {children}
          <Footer />
        </div>
      </div>
    </>
  );
};
